export default "__VITE_ASSET__Ctlp0TF7__"